// Test Firebase connectivity
import { collection, doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from './firebase/config';

const testFirebaseConnection = async () => {
  try {
    console.log('Testing Firebase connection...');
    
    // Try to write a simple test document
    const testRef = doc(collection(db, 'test'), 'connectivity-test');
    await setDoc(testRef, {
      message: 'Firebase connection test',
      timestamp: new Date().toISOString()
    });
    
    console.log('✅ Write operation successful');
    
    // Try to read the document back
    const testDoc = await getDoc(testRef);
    if (testDoc.exists()) {
      console.log('✅ Read operation successful:', testDoc.data());
      return true;
    } else {
      console.log('❌ Document not found after write');
      return false;
    }
  } catch (error) {
    console.error('❌ Firebase test failed:', error);
    return false;
  }
};

// Run the test
testFirebaseConnection().then(result => {
  console.log('Firebase test result:', result);
}).catch(error => {
  console.error('Firebase test error:', error);
});
